"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
require("./search.scss");
var React = require("react");
var theme_1 = require("~@/widget/theme/theme");
var search_recommend_1 = require("~@/widget/search-recommend/search-recommend");
var search_auto_complete_1 = require("~@/widget/search-auto-complete/search-auto-complete");
var stat_1 = require("~@/widget/stat/stat");
var REG = {
    IN_SEARCH: /^https?:\/\/www\.yy\.com\/search-([^?#]*.*$)/
};
var Search = (function (_super) {
    __extends(Search, _super);
    function Search(props) {
        var _this = _super.call(this, props) || this;
        var inSearch = '';
        var iLocation = window.location.href;
        if (iLocation.match(REG.IN_SEARCH)) {
            inSearch = decodeURIComponent(iLocation.replace(REG.IN_SEARCH, '$1')).replace(/\?$/, '');
        }
        _this.searchArea = React.createRef();
        _this.searchForm = React.createRef();
        _this.searchRecommend = React.createRef();
        _this.searchInput = React.createRef();
        _this.searchAutoComplete = React.createRef();
        _this.state = {
            val: '',
            curSearchType: undefined,
            inputFocus: false,
            selectHover: false,
            inSearch: inSearch,
            enableRecommend: false,
            enableAutoComplete: false
        };
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleFocus = _this.handleFocus.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.handleKeybord = _this.handleKeybord.bind(_this);
        _this.handleSelectEnter = _this.handleSelectEnter.bind(_this);
        _this.handleSelectLeave = _this.handleSelectLeave.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        return _this;
    }
    Search.prototype.componentDidMount = function () {
        var _this = this;
        var themeInfo = this.props.themeInfo;
        var searchMeta = themeInfo.searchMeta;
        var _a = this, searchArea = _a.searchArea, searchInput = _a.searchInput;
        if (searchMeta) {
            this.setState({
                curSearchType: searchMeta.opts[searchMeta.current]
            });
        }
        document.addEventListener('click', function (e) {
            var _a = _this.state, inputFocus = _a.inputFocus, enableRecommend = _a.enableRecommend, enableAutoComplete = _a.enableAutoComplete;
            if (enableRecommend || enableAutoComplete) {
                var currentEl = e.target;
                var inside = false;
                if (!inputFocus &&
                    !searchArea.current.contains(currentEl)) {
                    _this.setState({
                        enableRecommend: false,
                        enableAutoComplete: false
                    });
                }
            }
        });
    };
    Search.prototype.render = function () {
        var _this = this;
        var _a = this.props, hotkey = _a.hotkey, themeInfo = _a.themeInfo;
        var type = themeInfo.type, searchMeta = themeInfo.searchMeta;
        var _b = this.state, val = _b.val, curSearchType = _b.curSearchType, inputFocus = _b.inputFocus, selectHover = _b.selectHover, inSearch = _b.inSearch, enableRecommend = _b.enableRecommend, enableAutoComplete = _b.enableAutoComplete;
        var searchAction;
        var keywordName = '';
        var typeName = '';
        if (searchMeta && curSearchType) {
            if (curSearchType.value === -1) {
                searchAction = theme_1.DOMAIN + "/search-" + (val || inSearch || hotkey);
            }
            else {
                searchAction = searchMeta.action;
                keywordName = searchMeta.keywordName;
                typeName = searchMeta.searchTypeName;
            }
        }
        else {
            searchAction = theme_1.DOMAIN + "/search-" + (val || inSearch || hotkey);
        }
        return (React.createElement("div", { className: "p-header__search", id: "pHeaderSearch", ref: this.searchArea },
            React.createElement("form", { className: "p-header__search__form " + (val ? 'p-header__search__form--has-word' : '') + " " + (inputFocus ? 'p-header__search__form--focus' : ''), target: inSearch ? '_self' : '_blank', method: "get", onSubmit: this.onSubmit, action: searchAction, ref: this.searchForm },
                React.createElement("div", { className: "p-header__search__main " + (searchMeta ? 'p-header__search__main--with-select' : '') },
                    searchMeta && curSearchType && (React.createElement(React.Fragment, null,
                        React.createElement("input", { type: "hidden", name: typeName, value: curSearchType.value }),
                        React.createElement("div", { className: "p-header__search__selector", onMouseEnter: this.handleSelectEnter, onMouseLeave: this.handleSelectLeave },
                            React.createElement("span", { className: "p-header__search__selector__opt" }, curSearchType.text),
                            React.createElement("i", { className: "p-header__search__selector__arr" }),
                            React.createElement("div", { className: "p-header__search__selector__opts " + (selectHover ? 'p-header__search__selector__opts--show' : '') }, searchMeta.opts.map(function (item, i) {
                                return (React.createElement("a", { key: i, "data-val": item.value, className: "p-header__search__selector__opts__item", href: "javascript:;", onClick: _this.handleSelectClick.bind(_this, item) }, item.text));
                            }))))),
                    React.createElement("div", { className: "p-header__search__s1" },
                        !searchMeta && (React.createElement(React.Fragment, null,
                            React.createElement("label", { className: "p-header__search__s1__icon", htmlFor: "wHeadSearch" }),
                            React.createElement("label", { className: "p-header__search__s1__placeholder", htmlFor: "wHeadSearch" }, "\u4E3B\u64AD/\u9891\u9053/\u5206\u7C7B"),
                            React.createElement("label", { className: "p-header__search__s1__hot-key", htmlFor: "wHeadSearch" }, inSearch || hotkey))),
                        React.createElement("input", { ref: this.searchInput, className: "p-header__search__s1__ipt", type: "text", autoComplete: "off", name: keywordName, value: val, onChange: this.handleChange, onKeyUp: function (e) { return _this.handleKeybord; }, onKeyDown: this.handleKeybord, onFocus: this.handleFocus, onBlur: this.handleBlur }),
                        React.createElement("div", { className: "p-header__search__btn" },
                            React.createElement("input", { className: "p-header__search__btn__ipt", id: "wHeadSearch", type: "submit", value: "\u641C\u7D22" }))))),
            React.createElement(search_recommend_1.SearchRecommend, { val: val, enablePopup: enableRecommend, ref: this.searchRecommend, search: function (str) { return _this.search(str); }, setKeyword: function (str) { return _this.setKeyword(str); } }),
            React.createElement(search_auto_complete_1.SearchAutoComplete, { val: val, enablePopup: enableAutoComplete, ref: this.searchAutoComplete, search: function (str) { return _this.search(str); }, setKeyword: function (str) { return _this.setKeyword(str); } })));
    };
    Search.prototype.handleChange = function (event) {
        var _this = this;
        var iVal = event.currentTarget.value;
        var rVal = iVal.trim();
        this.setState({
            val: iVal,
            enableRecommend: rVal === '',
            enableAutoComplete: rVal !== ''
        }, function () {
            if (_this.state.enableAutoComplete) {
                _this.searchAutoComplete.current.fetchKeyword(_this.state.val);
                stat_1.stat(stat_1.EStatType.SEARCH_INPUT_CHANGE, [iVal]);
            }
        });
    };
    Search.prototype.handleKeybord = function (e) {
        var _a = this.state, enableRecommend = _a.enableRecommend, enableAutoComplete = _a.enableAutoComplete;
        switch (e.key) {
            case 'ArrowDown':
                if (enableRecommend) {
                    this.searchRecommend.current.changeCurrent(1);
                }
                if (enableAutoComplete) {
                    this.searchAutoComplete.current.changeCurrent(1);
                }
                break;
            case 'ArrowUp':
                if (enableRecommend) {
                    this.searchRecommend.current.changeCurrent(-1);
                }
                if (enableAutoComplete) {
                    this.searchAutoComplete.current.changeCurrent(-1);
                }
                break;
            case 'Escape':
                this.setState({
                    enableRecommend: false,
                    enableAutoComplete: false
                });
                break;
        }
    };
    Search.prototype.handleFocus = function () {
        var _this = this;
        var val = this.state.val;
        var searchInput = this.searchInput;
        var iVal = val.trim();
        this.setState({
            inputFocus: true,
            enableRecommend: iVal === '',
            enableAutoComplete: iVal !== ''
        }, function () {
            if (_this.state.enableAutoComplete) {
                _this.searchAutoComplete.current.fetchKeyword(iVal);
            }
        });
    };
    Search.prototype.handleBlur = function () {
        this.setState({
            inputFocus: false
        });
    };
    Search.prototype.onSubmit = function (e) {
        var _this = this;
        var _a = this.state, curSearchType = _a.curSearchType, val = _a.val, inSearch = _a.inSearch;
        var hotkey = this.props.hotkey;
        var rVal = val.trim();
        if (!curSearchType && !rVal) {
            rVal = inSearch || hotkey;
        }
        if (rVal) {
            this.setState({
                val: rVal
            }, function () {
                _this.searchRecommend.current.onSubmit(rVal);
            });
            stat_1.stat(stat_1.EStatType.SEARCH_KEYWORD, [rVal]);
        }
        else {
            e.preventDefault();
        }
    };
    Search.prototype.handleSelectEnter = function () {
        this.setState({
            selectHover: true
        });
    };
    Search.prototype.handleSelectLeave = function () {
        this.setState({
            selectHover: false
        });
    };
    Search.prototype.handleSelectClick = function (item) {
        this.setState({
            selectHover: false,
            curSearchType: item
        });
    };
    Search.prototype.setKeyword = function (keyword) {
        var searchInput = this.searchInput;
        this.setState({
            val: keyword
        });
    };
    Search.prototype.search = function (keyword) {
        var _a = this, searchForm = _a.searchForm, searchInput = _a.searchInput;
        this.setState({
            val: keyword,
            enableRecommend: false,
            enableAutoComplete: false
        }, function () {
            searchForm.current.submit();
            searchInput.current.blur();
        });
    };
    return Search;
}(React.Component));
exports.Search = Search;
